<template>
    <div id="users-page" class="wide content">
        <h3>Users</h3>

        <div class="users">
            <div class="list">
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>E-mail</th>
                            <th>Username</th>
                            <th class="actions">&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in users" :key="user.id">
                            <td>{{ user.name }}</td>
                            <td>{{ user.email }}</td>
                            <td>{{ user.username }}</td>
                            <td>
                                <div class="actions">
                                    <a href="#" @click.prevent="getUserDetail(user.id)">Edit</a> &nbsp;
                                    <a href="#" @click.prevent="confirmDelete(user)">Delete</a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="edit">
                <form @submit.prevent="saveUser" v-if="editUser" autocomplete="new-password">
                    <p>
                        <label>First Name
                            <input type="text" name="firstname" v-model="editUser.firstname" required>
                        </label>
                    </p>
                    <p>
                        <label>Last Name
                            <input type="text" name="lastname" v-model="editUser.lastname" required>
                        </label>
                    </p>
                    <p>
                        <label>Industry Role
                            <input type="text" name="industry_role" v-model="editUser.industry_role" placeholder="Select or enter your role" list="role_list" autocomplete="off" required>
                            <datalist id="role_list">
                                <option value="Bank Office/Operations" />
                                <option value="Data Provider" />
                                <option value="Trustee" />
                                <option value="Lender" />
                                <option value="Investor" />
                                <option value="Issuer" />
                                <option value="NSRO" />
                                <option value="Servicer" />
                                <option value="Underwriter" />
                            </datalist>
                        </label>
                    </p>
                    <p>
                        <label>Company
                            <input type="text" name="company" v-model="editUser.company" required>
                        </label>
                    </p>
                    <p>
                        <label>Address
                            <input type="text" name="address" v-model="editUser.address" required>
                        </label>
                    </p>
                    <p>
                        <label>Suite/Apt
                            <input type="text" name="address2" v-model="editUser.address2">
                        </label>
                    </p>
                    <p>
                        <label>City
                            <input type="text" name="city" v-model="editUser.city" required>
                        </label>
                    </p>
                    <p>
                        <label>State
                            <input type="text" name="state" v-model="editUser.state" required>
                        </label>
                    </p>
                    <p>
                        <label>ZIP Code
                            <input type="text" name="zipcode" v-model="editUser.zipcode" required>
                        </label>
                    </p>
                    <p>
                        <label>User ID
                            <input type="text" name="user" v-model="editUser.username" required>
                        </label>
                    </p>
                    <p>
                        <label>Email
                            <input type="email" name="email" v-model="editUser.email" required>
                        </label>
                    </p>
                    <p>
                        <label>Work Phone
                            <input type="tel" name="workphone" v-model="editUser.work_phone">
                        </label>
                    </p>
                    <p>
                        <label>Change Password
                            <input autocomplete="new-password" type="password" name="password" v-model="editUser.password">
                        </label>
                    </p>
                    <p>
                        <label>Confirm Password
                            <input autocomplete="new-password" type="password" name="confirm_password" v-model="editUser.confirm_password" :required="!!editUser.password">
                            <small v-if="editUser.password != editUser.confirm_password">
                                Passwords do not match
                            </small>
                        </label>
                    </p>
                    <p>
                        <label>Folder Access
                            <div class="user-access">
                                <div class="folder" v-for="(folder, index) in folders" :key="index">
                                    <a href="javascript:void(0)" @click="folder._selected = !folder._selected" :style="`margin-left: ${(getLevel(folder) - 1) * 14}px`">
                                        <i :class="['far', 'fa-fw', !!folder._selected ? 'fa-check-square' : 'fa-square']"></i>{{ folder.display_name }}
                                    </a>
                                </div>
                            </div>
                        </label>
                    </p>
                    <p>
                        <label><input type="checkbox" name="superuser" v-model="editUser.superuser"> 
                            Admin User
                        </label>
                    </p>
                    <p>
                        <button type="submit">Save</button> &nbsp;
                        <button class="cancel" @click.prevent="editUser = null">Cancel</button>
                    </p>
                </form>
            </div>
        </div>
        <modal ref="confirm">
            <h5>Confirm Deletion</h5>
            <p v-if="targetUser">
                Are you sure you want to delete <em>{{targetUser.name}}</em>?
            </p>
            <p>
                <button @click.prevent="deleteTargetUser">Yes</button>
                <button class="cancel" @click.prevent="$refs.confirm.close()">No</button>
            </p>
        </modal>
    </div>
</template>
<script>
import {mapState} from 'vuex'

import axios from 'axios'
import Modal from '../components/Modal.vue'

export default {
    name: 'users-page',
    components: {Modal},
    data() {
        return {
            folders: [],
            users: [],
            editUser: null,
            targetUser: null,
        }
    },
    computed: {
        ...mapState(['user']),
    },
    methods: {
        async saveUser() {
            if (!!this.editUser.password && this.editUser.password != this.editUser.confirm_password) {
                return false;
            }

            let folder_access = this.folders.filter(f => f._selected).map(f => f.folder)
            this.editUser.folder_access = folder_access

            let r
            if (!this.editUser.id) {
                r = await axios.post('/api/users', {
                    user: this.editUser
                })
            }
            else {
                if (!!this.editUser.password && this.user.id != this.editUser.id) {
                    this.editUser.reset_pw_next = true
                }

                r = await axios.put(`/api/users/${this.editUser.id}`, {
                    user: this.editUser
                })
            }

            if (r.status != 200) {
                return;
            }

            this.editUser = null
            this.getUsers()
        },
        getLevel(folder) {
            return folder.folder.split('.').length - 1
        },
        async getUserDetail(id) {
            for (let f of this.folders) {
                f._selected = false
            }

            let r = await axios.get(`/api/users/${id}`)
            if (r.status != 200) {
                return;
            }

            this.editUser = r.data.user

            for (let f of this.folders) {
                f._selected = this.editUser.folder_access.indexOf(f.folder) !== -1
            }
        },
        confirmDelete(user) {
            this.targetUser = user

            this.$nextTick(() => {
                this.$refs.confirm.showModal()
            })
        },
        async deleteTargetUser() {
            let r = await axios.delete(`/api/users/${this.targetUser.id}`)
            if (r.status != 200) {
                return;
            }

            this.$refs.confirm.close()
            this.targetUser = null
            this.getUsers()
        },
        async getAllFolders() {
            let r = await axios.get('/api/files/get-all-folders')

            if (r.status != 200) {
                return;
            }

            this.folders = r.data.files

            for (let f of this.folders) {
                this.$set(f, '_selected', false)
            }
        },
        async getUsers() {
            let r = await axios.get('/api/users')

            if (r.status != 200) {
                return;
            }

            this.users = r.data.users
        },
    },
    created() {
        this.getUsers()
        this.getAllFolders()
    }
}
</script>
<style lang="scss">
@import '../scss/include-media';
#users-page {
    padding: 50px 100px;
    @include media("<=tablet") {
        padding: 50px;
    }
    &.content {
        @include media(">tablet") {
            max-width: 65vw;
        }
    }
    min-height: 55vh;

    .users {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-areas: "list edit";
        grid-gap: 2rem;

        .list {
            // grid-column: 1/2;
            grid-area: list;
        }
        .edit {
            // grid-column: 2/3;
            grid-area: edit;

            label {
                display: block;
            }
        }

        .user {
            padding-bottom: 1rem;
            margin-bottom: 1rem;
            border-bottom: solid 1px #333;
            p {
                margin-bottom: 0.25rem;
            }
        }

        table {
            border-collapse: collapse;
            td, th {
                border: solid 1px #cacaca;
            }
            th.actions {
                width: 6.5rem;
            }
            td .actions {
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
            }
            tbody tr:nth-child(odd) td {
                background: #f5f5f5;
            }

            tbody tr:hover td {
                /* background: hsl(148, 40%, 96%); */
                background: rgba(47, 103, 61, 0.05);
            }
        }

        .user-access {
            // max-height: 20rem;
            // overflow: auto;

            .folder {
                &:nth-child(odd) {
                    background: #eaeaea;
                }

                a {
                    display: block;
                    padding: 0.5rem;
                }
            }
            
        }
    }

}
</style>
